import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { LookUpKeyValueforDomainList } from 'src/app/model/lov';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { ItemPackaging } from 'src/app/model/reverse/item-packaging.model';
import { ItemSummay, KitItemDetails, RItemMaster, unifiedItemModel, ItemErrorsResponse, filterRequest, HazmatInfo } from 'src/app/model/item';
import { RefCodeService } from './ref-code.service';

@Injectable({
  providedIn: 'root'
})

export class ItemService {

  itemID = '';
  itemDetails: RItemMaster;
  UomMappings : any = {};
  dimnUomMapping = {};
  weightUomMapping = {};
  volumeUomMapping = {};
  itemUomMap = new Map();
  itemKitMap = new Map();
  hazmatInfoMap = new Map();
  showSaveItemOption = false;
  isValidItemData = true;
  editRow: any = '';
  editRow$ = new BehaviorSubject(this.editRow);
  categoryValues: any[] = [];
  categoryValues$ = new BehaviorSubject(this.categoryValues);
  itemTab = 0;
  currentTab = 0;
  currentTab$ = new BehaviorSubject(this.currentTab);
  currentAction = '';
  currentAction$ = new BehaviorSubject(this.currentAction);
  currentData: ItemSummay = new ItemSummay();
  currentData$ = new BehaviorSubject(this.currentData);
  showCasePickBtn = false;
  showCasePickBtn$ = new BehaviorSubject(this.showCasePickBtn);
  locationStatus = [];
  locationStatus$ = new BehaviorSubject(this.locationStatus);
  kitParent: unifiedItemModel = new unifiedItemModel();
  kitParent$ = new BehaviorSubject(this.kitParent);
  filterRequest = new filterRequest();
  packagingInfoSaved = false;
  packagingInfoSaved$ = new BehaviorSubject(this.packagingInfoSaved);
  itemTracking : any = {};
  itemTracking$ = new BehaviorSubject(this.itemTracking);
  isItemSeriallyTracked:boolean = false;
  opsItemInitialRowData: any = {};
  opsItemRowData : any = {};
  opsItemRowData$ = new BehaviorSubject(this.opsItemRowData);
  private isUomDeletedFlagVal = false;  // Default value
  isUomDeletedFlagVal$ = new BehaviorSubject(this.isUomDeletedFlagVal);

  constructor(private http: HttpClient, private lookupSvc: RefCodeService) { }

  clearFilterRequest() {
    this.filterRequest = new filterRequest();
    this.currentData = new ItemSummay();
    this.currentData$.next(this.currentData);
    this.lookupSvc.currentLookupDataList.next(null);
  }

  updateItemSerialTrackingStatus(isItemSeriallyTracked: boolean) {
    this.isItemSeriallyTracked = isItemSeriallyTracked;
  }

  getItemSerialTrackingStatus(){
    return this.isItemSeriallyTracked;
  }

  updateItemRowData(rowData){
    this.opsItemInitialRowData = rowData;
  }

  getItemRowData(){
    return this.opsItemInitialRowData;
  }

  setDimnUomMapping(dimnUomMapping: {}) {
    this.dimnUomMapping = dimnUomMapping;
  }

  getDimnUomMapping() {
    return this.dimnUomMapping;
  }

  setWeightUomMapping(weightUomMapping: {}) {
    this.weightUomMapping = weightUomMapping;
  }

  getWeightUomMapping() {
    return this.weightUomMapping;
  }

  setVolumeUomMapping(volumeUomMapping: {}) {
    this.volumeUomMapping = volumeUomMapping;
  }

  getVolumeUomMapping() {
    return this.volumeUomMapping;
  }

  addItemUomMapping(itemId: string, itmPackArray: ItemPackaging[]) {
    this.itemUomMap.set(itemId, itmPackArray);
  }

  addItemKitMapping(itemId: string, itemKitDetails: KitItemDetails[]) {
    this.itemKitMap.set(itemId, itemKitDetails);
  }

  clearItemUomMap() {
    this.itemUomMap.clear();
  }

  clearKitMap() {
    this.itemKitMap.clear();
  }

  getItemUomMap() {
    return this.itemUomMap;
  }

  setUomMapping(data) {
    this.UomMappings = data;
  }

  getUomMapping() {
    return this.UomMappings;
  }

  setItemId(data) {
    this.itemID = data;
  }

  getItemId() {
    return this.itemID;
  }

  setItemDetails(data) {
    this.itemDetails = data;
  }

  getItemDetails() {
    return this.itemDetails;
  }

  setUomDeletedFlag(value: boolean) {
    this.isUomDeletedFlagVal = value;
    this.isUomDeletedFlagVal$.next(this.isUomDeletedFlagVal);
  }

  resetUomDeletedFlag() {
    this.isUomDeletedFlagVal = false;
    this.isUomDeletedFlagVal$.next(this.isUomDeletedFlagVal);
  }

  getUomDeletedFlag() {
    return this.isUomDeletedFlagVal;
  }

  saveItem(itemRequest) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: 'Basic ' + btoa('PPPPortal:Fedex@123'),
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ITEM_SERVICE',
      'Access-Control-Allow-Origin': '*',
    });
    const options = { headers };
    return this.http.post(environment.apiOpsItemURL, itemRequest, options);

  }

  getRefCodesOfDomain(refWhsId, refDomainList, refConfigCusId) {
    return this.http.get('api/v1/getrefcodes/' + refWhsId + '/' + refConfigCusId + '/' + refDomainList);
  }

  getKeyValue(domainList: string[], facility: string, customerId: string): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { active: 'Y', lookupNames: domainList, fcyId: facility, cusId: customerId }
    };
    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL, httpOptions);
  }

  getLookupKeyValues(domainList: string[], facility: string, customerId: string, buId :string): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { active: 'Y', lookupNames: domainList, fcyId: facility, cusId: customerId ,buId: buId}
    };
    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL, httpOptions);
  }

  getItemsBySearchCriteria(itmId, itmDescription, itmDeletedFlag, itmCusId,fcyId,buId): Observable<any> {

    itmId = (itmId === null || itmId === '' || itmId === undefined) ? '' : itmId;
    itmDescription = (itmDescription  === null || itmDescription  === '' || itmDescription  === undefined) ? '' : itmDescription ;
    itmDeletedFlag = (itmDeletedFlag  === null || itmDeletedFlag  === '' || itmDeletedFlag  === undefined) ? 'N' : itmDeletedFlag ;

    // Encode each parameter properly
    const queryParams = `itemId=${encodeURIComponent(itmId)}&itmDesc=${encodeURIComponent(itmDescription)}&deleteFlag=${encodeURIComponent(itmDeletedFlag)}&customerId=${encodeURIComponent(itmCusId)}&type=items&fcyId=${encodeURIComponent(fcyId)}&buId=${encodeURIComponent(buId)}`;

    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      }
    };

    return this.http.get(`${environment.apiOpsItemURL}?${queryParams}`, httpOptions);
  }

  getInventoryMaster(fcyId: string, cusId: string, buId: string, itemId: string, locId: string): Observable<any> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
        fcy_id: fcyId,
        cust_id: cusId,
        bu_id: buId,
        item_id: itemId,
        location_id: locId
      }
    };
    return this.http.get<any>(environment.apiInventoryMasterURL, httpOptions);
  }

  addItemKittingMapping(itemId: string, itemDetail:KitItemDetails[]) {
    this.itemKitMap.set(itemId, itemDetail);
  }

  getItemKitMap() {
    return this.itemKitMap;
  }

  getItemInventory(itemId) {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID')
      },
      params: { item_id: itemId }
    };
    return this.http.get<any>(environment.apiInventoryURL + 'listforitem', httpOptions);
  }
  

  addHazmatInfoMapping(itemId: string, itemDetail: HazmatInfo) {
    this.hazmatInfoMap.set(itemId, itemDetail);
  }

  getHazmatInfoMap() {
    return this.hazmatInfoMap;
  }

  clearHazmatInfoMap() {
    this.hazmatInfoMap.clear();
  }

  getItemError(
    cusId: number,
    itemErrorId: number
  ):Observable<ItemErrorsResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        custId: cusId != undefined ? cusId.toString() : '0',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      },
      params: { itemErrorId: itemErrorId != undefined ? itemErrorId.toString() : '0' }
    };
    return this.http.get<ItemErrorsResponse>(
      environment.apiItemURL+"/error",
      httpOptions
   );
  }

  getNoItemFoundItemDetails(itemCode, CUST_ID, fcyId, buId): Observable<any> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        CUST_ID: CUST_ID,
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      },
      params: {
        fcyId: fcyId ? fcyId : '0',
        buId: buId ? buId : '0',
        itemCode: itemCode
      }
    };
    return this.http.get<any>(environment.apiItemURL + "/checkItem", httpOptions);
  }

  getKitItemDetails(itemCode, customerId, fcyId, buId): Observable<any> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        customerId: customerId,
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        buId: buId ? buId : '0',
        fcyId: fcyId ? fcyId : '0',
        FSC_USER: localStorage.getItem('USERID'),
      },
      params: {
        itemCode: itemCode
      }
    };
    return this.http.get<any>(environment.apiItemURL + "/getKitItemCodeDetails", httpOptions);
  }

  checkSerialNumberTrackedOrNot(itemCode, CUST_ID, fcyId, buId): Observable<any> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        CUST_ID: CUST_ID != undefined ? CUST_ID.toString() : '0',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      },
      params: {
        fcyId: fcyId ? fcyId : '0',
        buId: buId ? buId : '0',
        itemCode: itemCode
      }
    };
    return this.http.get<any>(environment.apiItemURL + "/checkSerialNumberTrack", httpOptions);
  }

  validateKits(kitComponents: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID')
      })
    };
    return this.http.post<any>(environment.apiItemURL + '/validate-kits', kitComponents, httpOptions);
  }

  clearFilterRequests() {
    this.filterRequest = new filterRequest();
  }
}
